var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTextbox = function SvgIconTextbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.688 10.5a1 1 0 0 1 1-1h2.625a1 1 0 0 1 0 2H7v2.375a1 1 0 1 1-2 0V11.5h-.312a1 1 0 0 1-1-1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.5 3.5a1 1 0 0 1 1 1v15a1 1 0 1 1-2 0v-1.25H2.25A1.75 1.75 0 0 1 .5 16.5v-9a1.75 1.75 0 0 1 1.75-1.75H9.5V4.5a1 1 0 0 1 1-1m-1 4.25h-7v8.5h7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.25 6.75a1 1 0 0 1 1-1h7.5A1.75 1.75 0 0 1 23.5 7.5v9a1.75 1.75 0 0 1-1.75 1.75h-7.5a1 1 0 1 1 0-2h7.25v-8.5h-7.25a1 1 0 0 1-1-1"
  }))));
};
export default SvgIconTextbox;